<template>
    <v-app>
        <v-navigation-drawer v-model="drawer"
                             clipped
                             fixed
                             app
                             dark
                             v-if="this.initialized
                                 && user.role !== 'builder'
                                 && user.role !== 'support'"
        >
            <div class="Sidebar__close-button">
                <v-btn @click="drawer = false"><v-icon small left>fas fa-times-circle</v-icon>Close</v-btn>
            </div>
            <sidebar />
        </v-navigation-drawer>

        <v-app-bar v-if="initialized"
                   app
                   class="elevation-0 Header"
                   fixed
                   dark
                   clipped-left
        >
            <div class="PrimaryMenuTrigger"
                 v-if="user.role !== 'builder' && user.role !== 'support'"
            >
                <v-btn icon
                       @click.stop="drawer = !drawer"
                       v-if="user.role !== 'builder' && user.role !== 'support'"
                >
                    <i class="fas fa-bars"></i>
                </v-btn>
            </div>

            <div class="PrimaryLogo" :class="{jsNoTrigger:user.role === 'support' || user.role === 'builder'}">
               <img src="@/assets/img/logo-white.svg" alt="">
            </div>
            <v-spacer></v-spacer>
            <page-header app v-if="authenticated" />
        </v-app-bar>

        <v-main v-if="this.initialized" app>
            <notification></notification>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </v-main>

        <page-footer />
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Sidebar from '../components/Sidebar/Sidebar';
import PageHeader from '../components/PageHeader';
import PageFooter from '../components/PageFooter';
import Notification from '../components/Notification';

export default {
    name: 'PrimaryLayout',

    components: {
        Notification,
        Sidebar,
        PageHeader,
        PageFooter,
    },

    data() {
        return {
            initialized: false,
            drawer: null,
        };
    },

    computed: {
        ...mapState('auth', ['user']),

        ...mapGetters({
            authenticated: 'auth/authenticated',
            sidebarOverlay: 'getSidebarLoader',
            sidebarMounted: 'getSidebarMounted',
        }),
    },

    mounted() {
        this.getAllSettings()
            .then(() => {
                this.initialized = true;
            });
    },

    methods: {
        ...mapActions({
            'getAllSettings': 'settings/getAllSettings',
        }),
    }
};
</script>

<style lang="scss">

.Header {
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
}

.PrimaryLogo {
    display: flex;
    flex-flow: row nowrap;
    align-content: center;
    align-items: center;
    flex: 0 0 40px;
    width: 40px;
    margin-right: 10px;
    padding-top: 3px;

    @media (min-width: 375px) {
        flex: 0 0 60px;
        width: 60px;
    }

    @media (min-width: 500px) {
        flex: 0 0 90px;
        width: 90px;
    }

    img {
        display: inline-block;
        width: 100%;
        height: auto;
    }

    &.jsNoTrigger {
        margin-left: 12px;
    }
}

.Sidebar__close-button {
    flex: 0 0 100%;
    width: 100%;
    padding: 20px 24px 0 20px !important;

    button {
        flex: 0 0 100%;
        width: 100%;
    }

    @media (min-width: 1263px) {
        display: none !important;
    }
}

</style>
